const CampaignDetailsStyles = (theme) => ({
	typography: {
		marginTop: 20,
		marginBottom: 10,
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit
	},
	margin: {
		marginTop: 20,
		marginBottom: 10,
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit
	},
	badgeMargin: {
		margin: theme.spacing.unit * 2,
	},
	button: {
		minWidth: 135,
		margin: theme.spacing.unit,
	},
	spacing: {
		marginTop: 20,
	},
	progress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -12,
		marginLeft: -12
	},
	progressInline: {
		margin: theme.spacing.unit
	},
	heading: {
		fontSize: theme.typography.pxToRem(16)
	},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(16),
		color: theme.palette.text.secondary
	},
	column: {
		flexGrow: 1,
	},
	center: {
		justifyContent: 'center',
		textAlign: 'center',
		height: 150,
		flexDirection: 'column',
		display: 'flex'
	}
});

export default CampaignDetailsStyles;